export function withdrawalContextQuery(client, currency, surface) {
    return {
        queryKey: ['onramp', client.cacheKey, 'withdrawal-context', currency, surface],
        queryFn: ({ signal }) => client.withdrawalContext(currency, surface, signal),
        staleTime: 30_000,
        networkMode: 'always',
        meta: { persist: false },
    };
}
